import React from "react";
import { useState } from "react";
import * as ManagedServiceStore from "../ManagedServiceStore";
import { ConfigFormField } from "../../organizations/OrganizationManagedServices";
import SquareButton from "../../general/SquareButton";
import { Button, Modal } from "../../components/Modal";
import { set } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const LinkManagedService = ({ organizationId, onDone }) => {
    const setConfig = (key) => (e) => {
        const newConfig = { ...newManagedService.configuration };
        set(newConfig, key, e.target.value);
        setNewManagedService({ ...newManagedService, configuration: newConfig });
    };

    const BoundConfigFormField = (key, name) => {
        return ConfigFormField(key, name, newManagedService.configuration, setConfig);
    };

    const [showModal, setShowModal] = useState(false);
    const [errors, setErrors] = useState([] as any[]);

    const [newManagedService, setNewManagedService] = useState({ type: 0, organizationId: organizationId, configuration: { name: "", link: "", imageURI: "", limitTo: "", openInIframe: false } } as any);

    const start = () => {
        setShowModal(true);
        setNewManagedService({ type: 0, organizationId: organizationId, configuration: { name: "", link: "", imageURI: "", limitTo: "", openInIframe: false } });
    };

    const complete = () => {
        ManagedServiceStore.CreateManagedService(organizationId, newManagedService)
            .then((response) => {
                setErrors([]);
                setShowModal(false);
                onDone();
            })
            .catch((error) => {
                if (error.response.data.errors && error.response.data.errors.length > 0) {
                    setErrors(error.response.data.errors);
                }
            });
    };

    return (
        <>
            <>
                <SquareButton className="col" onClick={start}>
                    Link
                    <br />
                    {/* @ts-ignore */}
                    <FontAwesomeIcon icon={["fad", "circle-plus"]} size="lg" className="text-blue-600"></FontAwesomeIcon>
                </SquareButton>
            </>
            <Modal isOpen={showModal} onClose={() => setShowModal(false)} title="New Link Managed Service" icon={["fad", "link"]} iconColor="text-blue-600" size="lg">
                <div className="p-6">
                    {BoundConfigFormField("name", "Name")}
                    {BoundConfigFormField("link", "Link")}
                    {BoundConfigFormField("imageURI", "Image URI")}
                    {BoundConfigFormField("limitTo", "Limit To")}
                    
                    <div className="form-group">
                        <label className="flex items-center gap-3 cursor-pointer">
                            <input 
                                type="checkbox" 
                                checked={newManagedService.configuration.openInIframe || false}
                                onChange={(e) => {
                                    const newConfig = { ...newManagedService.configuration };
                                    newConfig.openInIframe = e.target.checked;
                                    setNewManagedService({ ...newManagedService, configuration: newConfig });
                                }}
                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                            />
                            <span className="text-sm font-medium text-gray-700">Open in iframe</span>
                        </label>
                        <p className="text-xs text-gray-500 mt-1 ml-7">When enabled, the link will open in an embedded iframe instead of a new tab</p>
                    </div>

                    {errors.length > 0 && (
                        <div className="bg-red-50 border border-red-200 rounded-md p-4 mb-4">
                            {errors.map((error, i) => (
                                <p key={i} className="text-red-800 text-sm">
                                    {error.message}
                                </p>
                            ))}
                        </div>
                    )}
                </div>
                <div className="border-t border-gray-200 bg-gray-50 px-6 py-4 flex justify-end space-x-3">
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={complete}>
                        Create
                    </Button>
                </div>
            </Modal>
        </>
    );
};

export const RenderLinkRow = (configuration: any) => {
    return (
        <>
            <td>
                <img src={configuration.imageURI} style={{ maxHeight: "50px" }} alt="" />
            </td>
            <td>
                {configuration.name}{" "}
                <a href={configuration.link} target="_blank">
                    Link
                </a>
            </td>
        </>
    );
};
